import { FETCH_PRODUCT_PORTALS } from '../actions/types'

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_PORTALS:
      return {
        ...state,
        [action.id]: action.payload
      }
    default:
      return state
  }
}
